import { Server, Layout, Database, Shield, Globe, Activity, Box } from 'lucide-react';

const ICONS: Record<string, React.ReactNode> = {
  Server: <Server size={24} />,
  Layout: <Layout size={24} />,
  Database: <Database size={24} />,
  Shield: <Shield size={24} />,
  Globe: <Globe size={24} />,
  Activity: <Activity size={24} />,
};

export const DemoIcon = ({ name }: { name: string }) => {
  return <>{ICONS[name] || <Box size={24} />}</>;
};
